// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 526 ? "html2canvas" : chunkId) + "." + {"453":"d4c0980a","526":"f7ae911e"}[chunkId] + ".chunk.js";
};